import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class riskTypesDisplayListCtrl implements IController {
  ids: any;
  isRow: any;
  onChange: Function;

  private displayItems: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    // if (this.ids && this.ids.length) {
    //
    // } else {
    //   this.displayItems = [];
    // }
  }

  $onChanges(changes) {
    if (changes.ids) {
      this.$onInit();
    }
  }

  onRemove(id) {
    this.onChange({ids: _.filter(this.ids, (i) => {return i !== id})});
  }



}

angular
  .module('bringoz.admin.deliveries')
  .component('riskTypesDisplayList', {
    bindings: {
      ids: '<',
      isRow: '<?',
      onChange: '&'
    },
    template: require('./risk-types-display-list.html').default,
    controller: riskTypesDisplayListCtrl
  });
